<template>
  <div class="tongxin-layout">
    <TongxinHeader />
    <router-view :key="$route.name" />
  </div>
</template>

<!-- this landing page currently serves as single source of entrace for tongxin related pages -->

<script>
import TongxinHeader from '@/components/web/proj/tongxin-demo/layout/Header.vue'

export default {
  name: "Layout",
  components: {
    TongxinHeader
  }
};
</script>

<style lang="scss">
.tongxin-layout {
  * {
    font-family: 'Microsoft JhengHei', '微軟正黑體', sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  .text-green {
    color: #207868 !important;
  }

  .text-purple {
    color: #8b5cf6 !important;
  }

  .text-yellow {
    color: #f59e0b !important;
  }

  .heading-icon {
    width: 60px;
    height: 60px;
    background: #bbb;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    animation: scaleIn 0.5s ease-out;

    @media (min-width: 768px) {
      width: 80px;
      height: 80px;
    }

    & svg {
      width: 30px;
      height: 30px;
      color: #fff;

      @media (min-width: 768px) {
        width: 40px;
        height: 40px;
      }
    }
  }

  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0.5);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .title-with-underline {
    margin-bottom: 40px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #207868;
    position: relative;

    @media (min-width: 768px) {
      font-size: 28px;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -12px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 3px;
      background: #2a9d8f;
      border-radius: 2px;
    }
  }

  .reminder-grayscale {
    margin-bottom: 24px;
    border-radius: 12px;
    padding: 16px;
    background: #f8f9fa;
    line-height: 1.8;
  }

  .reminder-green {
    margin-bottom: 24px;
    border: 1px solid #2a9d8f;
    border-radius: 8px;
    padding: 16px;
    background: #e8f5f3;
    color: #207868;
    font-size: 16px;
    line-height: 1.8;
  }

  .btn {
    padding: 12px 20px;
    font-size: 16px;
    border: none;
    border-radius: 60px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    @media (min-width: 425px) {
      padding: 18px 30px;
      font-size: 24px;
    }

    @media (min-width: 768px) {
      max-width: 300px;
    }

    &:disabled {
      background: #e9ecef;
      color: #999;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }

    &:not(:disabled):hover {
      transform: translateY(-3px);
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg,transparent,rgba(255,255,255,.2),transparent);
      transition: left .5s;
    }

    &:not(:disabled):hover::before {
      left: 100%;
    }

    &.btn-secondary {
      background: #f8f9fa;
      color: #666;
      border: 2px solid #e9ecef;

      &:not(:disabled):hover {
        background: #e9ecef;
        color: #495057;
      }
    }

    &.btn-primary {
      background: linear-gradient(135deg, #164d43 0%, #207868 100%);
      color: white;

      &:not(:disabled):hover {
        box-shadow: 0 5px 15px rgba(32, 120, 104, 0.3);
      }
    }

    &.btn-danger {
      background: linear-gradient(135deg,#dc2626 0%,#ef4444 100%);
      color: #fff;
      box-shadow: 0 5px 20px rgba(220,38,38,.3);

      &:not(:disabled):hover {
        background: linear-gradient(135deg,#b91c1c 0%,#dc2626 100%);
        box-shadow: 0 8px 25px rgba(220,38,38,.4);
      }
    }
  } // end of .btn
}
</style>
